<div
  #historyContainer
  class=" tw-relative tw-flex tw-flex-col tw-flex-1 tw-overflow-y-auto tw-p-4 tw-space-y-2 tw-bg-slate-50 tw-min-h-[200px]"
  style="height: calc(100vh - 200px)"
  (scroll)="onScroll()"
>
  @if (kiService.loadingHistory()) {
    <div class="tw-flex tw-w-full tw-h-18">
      <sb-loading-spinner></sb-loading-spinner>
    </div>
  }
  @for (msg of kiService.history(); track $index) {
    <div
      class="tw-flex tw-w-full"
      [ngClass]="{
          'tw-justify-end': msg.response,
          'tw-justify-start': !msg.response
        }"
    >
      <div
        class="tw-max-w-[75%] tw-rounded-2xl tw-px-3 tw-py-2 tw-text-sm tw-shadow-sm"
        [ngClass]="{
            'tw-bg-blue-600 tw-text-white': msg.response,
            'tw-bg-white tw-text-slate-800 tw-border tw-border-slate-200':
              !msg.response
          }"
      >
        <div class="">
          {{ msg.response?.length > 0 ? msg.response : msg.message }}
        </div>
        @let navigations = checkForValidNavigationDTOs(msg.navigationDTO);
        @if (navigations && navigations.length > 0) {
          <div class="tw-mt-2">Link:</div>
          @for (nav of navigations; track $index) {
            <a
              class="nav-link tw-text-underline tw-cursor-pointer"
              [sbRouterLink]="nav.routingId"
              [pathParams]="nav.pathParameter"
              [queryParams]="nav.queryParameter"
              (click)="kiService.closeKIPanel()"
            >
              {{ nav.routingId }}
            </a>
          }
        }
        <div
          class="tw-mt-1 tw-text-[10px] tw-text-slate-400 tw-text-right"
        >
          {{ msg.timestamp?.toString() | date: 'dd.MM.yy HH:mm:ss' }}
        </div>
      </div>
    </div>
  }
</div>
